import { isNil } from 'lodash';

export const sanitizeContext = (context: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(context).filter(([, value]) => !isNil(value)),
  );
